import { AxiosRequest } from "../common/axios-request";
import { CREATE_FACILITY, DELETE_FACILITY, GET_ALL_FACILITY_LIST, GET_FACILITY_DETAILS, UPDATE_FACILITY } from "../common/constant";

const GetFacilitiesList = (isActive: string = "") => {
    return AxiosRequest.get(GET_ALL_FACILITY_LIST(isActive))
}

const GetFacilityDetail = (id: string) => {
    return AxiosRequest.get(GET_FACILITY_DETAILS.replace(":id", id))
}

const CreateFacility = (payload: any) => {
    return AxiosRequest.post(CREATE_FACILITY, payload)
}

const UpdateFacility = (id: string, payload: any) => {
    return AxiosRequest.put(UPDATE_FACILITY.replace(":id", id), payload)
}

const DeleteFacility = (id: string) => {
    return AxiosRequest.delete(DELETE_FACILITY.replace(":id", id))
}

export { GetFacilitiesList, GetFacilityDetail, CreateFacility, UpdateFacility, DeleteFacility }